import { atom } from 'recoil';

export const licenseListAtom = atom({
  key: 'licenseListAtom_v1',
  default: { licenses: [], count: 0 },
});

export const licenseFormDialogOpenAtom = atom({
  key: 'licenseFormDialogOpenAtom_v1',
  default: false,
});
